import LoyaltyListingSFC from "./LoyaltyListing.vue";
export const LoyaltyListing = LoyaltyListingSFC;
